import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { fromUnixTime, getTime } from 'date-fns';

export function useCountdown(
  targetUnixTime,
  hideCta = false,
  ctaContainerId = '',
  defaultHiddenCtaClass = 'hidden-forced',
) {
  const targetTime = getTime(fromUnixTime(targetUnixTime));
  const intervalTime = ref(0);
  const intervalId = ref(null);

  const isActive = computed(() => intervalTime.value >= 0);
  const shouldShowCta = computed(() => !isActive.value && hideCta);

  const setIntervalTime = () => {
    const currentTime = getTime(new Date());
    intervalTime.value = targetTime - currentTime;
  };

  const startIntervalTime = () => {
    if (!isActive.value) {
      return;
    }

    intervalId.value = setInterval(() => {
      setIntervalTime();
    }, 1000);
  };

  const showCta = () => {
    const element = document.getElementById(ctaContainerId);
    if (!element) {
      return;
    }
    element.classList.remove(defaultHiddenCtaClass);
  };

  watch(shouldShowCta, (hide) => {
    if (!hide) {
      return;
    }
    showCta();
  });

  watch(isActive, (active) => {
    if (active || !intervalId.value) {
      return;
    }
    clearInterval(intervalId.value);
  });

  onMounted(() => {
    setIntervalTime();
    startIntervalTime();
  });

  onUnmounted(() => {
    if (!intervalId.value) {
      return;
    }
    clearInterval(intervalId.value);
  });

  return {
    isActive,
    shouldShowCta,
    intervalTime,
  };
}
